/**
 * Enlaces a los documentos legales y la identidad de este cliente ante la
 * callable `acceptLegalTerms` (ADR-SEC-013 local, 2026-10-04).
 *
 * Los enlaces son los mismos en los tres entornos —el texto vive en el sitio
 * público (`quizoteca-homepage`)—, así que no son un parámetro de operación y no
 * van a `.env.*`. Abren en pestaña nueva.
 */
export const LEGAL_TERMS_URL = 'https://quizoteca.com/terminos'
export const LEGAL_PRIVACY_URL = 'https://quizoteca.com/privacidad'

/** Valor del enum `client` del contrato `accept_legal_terms` v1 para este repo. */
export const LEGAL_CLIENT_ID = 'quizoteca-student-portal' as const
